<template>
    <div class="footer-box">
        <div class="footer-l">
            <div class="footer-item1">精准教研-人工智能助推教师专业化成长</div>
            <div class="footer-item2">Copyright ©2024-精准教研；&nbsp;系统版本：V1.0.7</div>
            <div class="footer-item2">
                地址：山西省大同市浑源县&nbsp;&nbsp;&nbsp;备案信息：<a target="_blank" href="https://beian.miit.gov.cn/">京ICP备2024046812号-6</a>
            </div>
        </div>
        <div class="footer-r">
            <div class="wechat-item">
                <img class="img-100" style="border-radius: 10px;" src="../assets/wechat_app.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<style scoped>
/*网站底部*/
.footer-box{
    width: 100%;
    height: 200px;
    background-color: #ff7f2e;
    display: flex;
}
.footer-l{
    width: 75%;
    height: 100%;
    padding-left: 50px;
}
.footer-item1{
    width: 100%;
    padding-top: 40px;
    height: 50px;
    line-height: 40px;
    font-size: 22px;
    text-align: left;
    color: #fff;
    font-weight: bold;
}
.footer-item2{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    text-align: left;
    color: #fff;
}
.footer-item2 a{
    color: #fff;
    text-decoration: none;
}
.footer-item2 a:hover{
    text-decoration: underline!important;
}
.footer-r{
    width: 25%;
    height: 100%;
}
.wechat-item{
    width: 140px;
    height: 140px;
    padding-top: 30px;
    padding-right: 40px;
    float: right;
}
</style>